import React, { useEffect } from 'react';
import { Modal, Form, Button } from 'antd';
import { LeadRequest } from '../../../../request/lead.request';
import { useLead } from '../../lead.hook';
import { LeadRes } from '../../../../response/lead.response';
import ApplicantComponent from './component/applicant.component';
import ImgIcon from '../../../../view/img-icon';
import PropertyDetailComponent from './component/property-detail.component';
import PriceDetailComponent from './component/price-detail.component';
import OtherDetailComponent from './component/other-detail.component';

export const CloseLeadComponent: React.FC<{ lead: LeadRes, open: boolean, onCancel: () => void, onLeadSuccess: () => void }> = ({ open, onCancel, onLeadSuccess }) => {
    const [form] = Form.useForm();
    const { loading, updateLoading, saveLead, fetchEmployeeList, fetchProjectList } = useLead()

    const handleOk = () => {
        form.validateFields().then(() => {
            updateLoading(true);
            const leadRequest = {

            } as LeadRequest
            setTimeout(() => {
                onSuccess()
            }, 2000)
            // saveLead(leadRequest, onSuccess, onFailure)
        });
    }

    const onSuccess = async () => {
        onLeadSuccess()
        form.resetFields()
        onCancel();
    }

    const onFailure = () => {
        updateLoading(false);
    }

    useEffect(() => {
        fetchEmployeeList()
        fetchProjectList()
    }, [])


    return (
        <Modal
            open={open}
            title="Close Lead"
            onCancel={onCancel}
            confirmLoading={loading}
            onOk={handleOk}
            okText={"Submit"}
            cancelText={"Cancel"}
            width={"100%"}
            style={{ top: 10 }}
            className='h-100 bg-white new-lead-form-modal'
        >
            <Form form={form} layout="vertical">

            <OtherDetailComponent />
                <ApplicantComponent />

                <Button type="link" style={{
                    marginLeft: '10px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    padding: 0
                }}>
                    <ImgIcon iconName="add-plus.svg" />
                    Add Co-applicant
                </Button>

                <PropertyDetailComponent />

                <PriceDetailComponent />

            </Form>
        </Modal>
    );
}